import React from 'react';

import axios from 'axios'
import { Table, Input, Button,Collapse,Popover,Popconfirm,message,Spin } from 'antd';

import Highlighter from 'react-highlight-words';
import Icon from '@ant-design/icons';
import { SearchOutlined,DeleteOutlined,DownloadOutlined,FundViewOutlined,LoadingOutlined,SwapOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import * as serverconfig from '../serverconn'
import CurrencyFormat from 'react-currency-format';
import FDAView from './AccountCreateFDAView'
import ReactExport from "@ibrahimrahmani/react-export-excel";

var CryptoJS = require("crypto-js");

const { Panel } = Collapse;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;

function callback(key) {
  console.log(key);
}

var sacco= ''
var token= ''
var username=''

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

class FixedDepositLists extends React.Component {
  state = {
    searchText: '',
    searchedColumn: '',
    fixeddeposits: [],
    datarequested:true,

  };

  componentDidMount(){

    if(localStorage.getItem("sacco")){
       sacco= CryptoJS.AES.decrypt(localStorage.getItem("sacco") , 'my-secret-key@12345').toString(CryptoJS.enc.Utf8)
       username= CryptoJS.AES.decrypt(localStorage.getItem("username") , 'my-secret-key@123').toString(CryptoJS.enc.Utf8)

      }else{
       sacco= ''
       username=''
    }
    
    if(localStorage.getItem("token")){
       token= localStorage.getItem("token")
    }else{
       token= ''
    }

    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }

    axios.get(serverconfig.backendserverurl+`/api/fixeddeposits/?sacco=${sacco}`)
    .then(res => {
        this.setState({
          fixeddeposits:res.data
        })

        this.setState({datarequested:false})

    })
}

 

getColumnSearchProps = dataIndex => ({
  filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
    <div style={{ padding: 8 }}>
      <Input
        ref={node => {
          this.searchInput = node;
        }}
        placeholder={`Search ${dataIndex}`}
        value={selectedKeys[0]}
        onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
        onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
        style={{ width: 188, marginBottom: 8, display: 'block' }}
      />
      <Button
        type="primary"
        onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
        icon={<SearchOutlined />}
        size="small"
        style={{ width: 90, marginRight: 8 }}
      >
        Search
      </Button>
      <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
        Reset
      </Button>
    </div>
  ),
  filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
  onFilter: (value, record) =>
    record[dataIndex]
      .toString()
      .toLowerCase()
      .includes(value.toLowerCase()),
  onFilterDropdownVisibleChange: visible => {
    if (visible) {
      setTimeout(() => this.searchInput.select());
    }
  },
  render: text =>
    this.state.searchedColumn === dataIndex ? (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[this.state.searchText]}
        autoEscape
        textToHighlight={text.toString()}
      />
    ) : (
      text
    ),
});

handleSearch = (selectedKeys, confirm, dataIndex) => {
  confirm();
  this.setState({
    searchText: selectedKeys[0],
    searchedColumn: dataIndex,
  });
};

handleReset = clearFilters => {
  clearFilters();
  this.setState({ searchText: '' });
};

  render() {
    const columns = [
      {
        title: 'Date of fixing',
        dataIndex: 'date',
        key: 'id',
        ...this.getColumnSearchProps('date'),
      },
      {
        title: 'Account Name',
        dataIndex: 'accountname',
        key: 'id',
        ...this.getColumnSearchProps('accountname'),
      },
      {
        title: 'Account Number',
        dataIndex: 'accountno',
        key: 'id',
        ...this.getColumnSearchProps('accountno'),
      },
      {
        title: 'Fixed Amount',
        dataIndex: 'fixedamount',
        key: 'id',
        render:text=><CurrencyFormat value={text} displayType={'text'} thousandSeparator={true}  />
      },

      {
        title: 'Period of fixing(Monthy)' ,
        dataIndex: 'period',
        key: 'id',
      }, 
      {
        title: 'Interest Rate',
        dataIndex: 'interestrate',
        key: 'id',
      },    
      {
        title: 'Interest Type',
        dataIndex: 'interesttype',
        key: 'id',
      }, 
      {
        title: 'Cleared',
        dataIndex: 'alreadyCleared',
        key: 'id',
        render:(text,record)=><p>{record.alreadyCleared===true?"Yes":"No"}</p>
      },      
      
      {
        title: 'Action',
        dataIndex: 'id',
        key: 'id',
        render: (text,record) =>
        <p>
        <Popover content={<p>Click here view schedule & statement</p>} title="Edit,View">
         <Link to={`/fixeddeposits/${text}`}><FundViewOutlined style={{color:'blue'}}/></Link>
        </Popover>

        &nbsp;&nbsp;&nbsp;
        <Popover content={<p>Click here to transfer fixed deposit and all due interest to savings</p>} title="Transfer to savings">
        <Popconfirm title="Sure to transfer?" 
         onConfirm={() =>{

          let form_data = new FormData();
          form_data.append('fixed_id',record.id);
          form_data.append('username', username);

          axios.post(serverconfig.backendserverurl+'/customqueries/fixedeposit_transfertosavings', form_data, {
            headers: {
              'content-type': 'multipart/form-data'
            }})
          .then(res => {
            this.setState({datarequested:false})
            message.info(res.data.message)
            //update data now
            axios.get(serverconfig.backendserverurl+`/api/fixeddeposits/?sacco=${sacco}`)
            .then(res => {
                this.setState({
                  fixeddeposits:res.data
                })
        
                this.setState({datarequested:false})
            })
            
          })
          .catch(error => console.log(error))

        }}>

        <SwapOutlined style={{color:'#154030',fontSize: '25px',alignSelf:'center'}} />
        </Popconfirm>

        </Popover>

        </p>,
        
      }

    ];

    if(this.state.datarequested===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
        <Spin indicator={antIcon} />
        </div>
      )

    }else{
      return(
        <div>
            <Collapse defaultActiveKey={['1']} onChange={this.callback}>
            <Panel header="FIXED DEPOSIT LIST" key="1">
            <br></br>

            <ExcelFile filename={"Pisacco - All Fixed deposit list"}  element={<Button type='primary' icon={<DownloadOutlined/>}>Download (Excel)</Button>}>
                <ExcelSheet data={this.state.fixeddeposits} name="Fixed deposits report">
                    <ExcelColumn label="Date of fixing" value="date"/>
                    <ExcelColumn label="Account name" value="accountname"/>
                    <ExcelColumn label="Account no" value="accountno"/>
                    <ExcelColumn label="Fixed amount " value="fixedamount"/>
                    <ExcelColumn label="Period " value="period"/>
                    <ExcelColumn label="Interest rate " value="interestrate"/>
                    <ExcelColumn label="Already cleared " value="alreadyCleared"/>

                </ExcelSheet>
            </ExcelFile>
           <br></br>


            <Table 
            columns={columns} 
            scroll={{ x: 1000 }}
            pagination={{showQuickJumper:true,showSizeChanger:true }}
            dataSource={this.state.fixeddeposits} 
            bordered/>
            </Panel>
            </Collapse>
            <br />
            <Collapse defaultActiveKey={['0']} onChange={callback}>
            <Panel header="Collapse Panel to open Form" key="1">
              <br></br>
              <FDAView />

            </Panel>
            </Collapse>
        </div>
    )

    }

  }
}

export default FixedDepositLists; 
